import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

export const MoreProjectsContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 680px;
  align-items: center;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 124px;

  & > *:last-child {
    margin: 0px;
  }
`;

export const MoreProjectsTitle = styled(Text).attrs({
  as: 'h3',
})`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray60};
    font-size: 16px;
    font-weight: ${theme.fontWeights.medium};
    display: flex;
    width: 100%;
    text-align: center;

    &:before,
    &:after {
      content: '';
      flex-basis: 64px;
      border-bottom: 1px solid ${theme.colorsV2.gray40};
      margin: auto;
    }

    &:before {
      margin-right: 16px;
    }

    &:after {
      margin-left: 16px;
    }
  `}
`;

export const SquareCardContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100vw;
    margin: 0 -16px 0 -16px;
    padding: 24px 16px;

    ${theme.mediaQueries.md} {
      width: 100%;
      padding: 24px 0;
      margin: unset;
    }

    & > * {
      margin: 8px;

      &:last-child {
        margin-right: auto;
      }

      &:first-child {
        margin-left: auto;
      }
    }
  `}
`;
